import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../component/sidebar";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../component/header";
import BasicTable from "../tables/BasicTable";
import {
  useGetDonationInformationsQuery,
  useUpdateDonationInformationMutation,
  useDeleteDonationInformationMutation,
  useAddDonationInformationMutation,
} from "../../../../services/donationInformationSlice";

import DonationInformationAddButton from "./donationInformationAddButton";

const DashboardDonationInformations = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <DashboardDonationInformationsPages />
      </Grid>
    </Grid>
  );
};

const DashboardDonationInformationsPages = () => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetDonationInformationsQuery("getDonationInformations");

  const [deleteDonationInformation] = useDeleteDonationInformationMutation();

  const deleteConfirm = (e, id) => {
    e.preventDefault();
    deleteDonationInformation({ id });
  };

  let headers = [];
  let tableData = [];
  let content;
  if (isLoading) {
    content = <p>"Loading..."</p>;
  } else if (isSuccess) {
    headers = [
      "Bank Information",
      "Online Information"
    ];
    tableData = [];
    data.ids.forEach((key) => {
      tableData.push({
        "Bank Information": data.entities[key].bank_information,
        "Online Information": data.entities[key].esewa_information,
        id: data.entities[key].id,
      });
    });
  }
  return (
    <>
      <Box className="table-design-background">
        <Grid container>
          <Grid item xs={6}>
            <Typography className="dashboard-home-page-text">
              DonationInformation Lists
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/dashboard/new/donation-informations">
              <DonationInformationAddButton />
            </Link>
          </Grid>
        </Grid>
        <Box style={{ padding: "1rem" }}>
          <BasicTable
            headers={headers}
            data={tableData}
            isDelete={true}
            deleteColor={"#f50057"}
            isEdit={true}
            editColor={"#3f51b5"}
            addColor={""}
            tableName={"donation-informations"}
            deleteConfirm={deleteConfirm}
          />
        </Box>
      </Box>
    </>
  );
};
export default DashboardDonationInformations;
